import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useFeatures, type Features } from "@/lib/features";

/**
 * Wraps a route element so it only renders when its feature flag is on.
 * While flags are still loading we render the children's background (cream)
 * to avoid a flash; once loaded, a disabled section redirects home.
 */
export default function FeatureGate({
  flag,
  children,
}: {
  flag: keyof Features;
  children: ReactNode;
}) {
  const { features, loading } = useFeatures();
  if (loading) {
    return <div className="min-h-dvh" style={{ backgroundColor: "#fff8ed" }} />;
  }
  if (!features[flag]) return <Navigate to="/" replace />;
  return <>{children}</>;
}
